import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { FIBU_KONTO_TYPEN, FibuKonto } from '../fibu-konto';

@Component({
    selector: 'kiene-fibu-konto-dialog',
    templateUrl: './fibu-konto-dialog.component.html',
    styleUrls: ['./fibu-konto-dialog.component.scss'],
})
export class FibuKontoDialogComponent implements OnInit {
    typen = FIBU_KONTO_TYPEN;
    isEdit = false;

    kontoNrCtrl = new UntypedFormControl('', [Validators.required]);
    bezeichnungCtrl = new UntypedFormControl('', [Validators.required]);
    kontoTypCtrl = new UntypedFormControl(1, [Validators.required]);
    sachkontoCtrl = new UntypedFormControl('');
    suffixCtrl = new UntypedFormControl('');
    aktivCtrl = new UntypedFormControl(true);
    kommentarCtrl = new UntypedFormControl('');

    private fibuKontoId: number = null;

    constructor(
        public dialogRef: MatDialogRef<FibuKontoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: { konto: FibuKonto },
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        const k = this.data?.konto;
        if (k?.fibu_konto_id) {
            this.isEdit = true;
            this.fibuKontoId = k.fibu_konto_id;
            this.kontoNrCtrl.setValue(k.konto_nr);
            this.bezeichnungCtrl.setValue(k.bezeichnung);
            this.kontoTypCtrl.setValue(k.konto_typ ?? 1);
            this.sachkontoCtrl.setValue(k.sachkonto);
            this.suffixCtrl.setValue(k.kostenstelle_suffix);
            this.aktivCtrl.setValue(k.aktiv > 0);
            this.kommentarCtrl.setValue(k.kommentar);
        }
    }

    onKontoNrBlur() {
        const nr: string = (this.kontoNrCtrl.value || '').trim();
        if (!nr) {
            return;
        }
        if (!this.sachkontoCtrl.value) {
            const punkt = nr.indexOf('.');
            if (punkt > 0) {
                this.sachkontoCtrl.setValue(nr.substring(0, punkt));
                if (!this.suffixCtrl.value) {
                    this.suffixCtrl.setValue(nr.substring(punkt + 1));
                }
            } else {
                this.sachkontoCtrl.setValue(nr);
            }
        }
    }

    isValid(): boolean {
        return this.kontoNrCtrl.valid && this.bezeichnungCtrl.valid && this.kontoTypCtrl.valid;
    }

    save() {
        if (!this.isValid()) {
            return;
        }
        const typ = Number(this.kontoTypCtrl.value);
        const body: any = {
            konto_nr: (this.kontoNrCtrl.value || '').trim(),
            bezeichnung: (this.bezeichnungCtrl.value || '').trim(),
            konto_typ: typ,
            konto_art: typ === 5 ? 'KREDITOR' : typ === 6 ? 'DEBITOR' : 'SACHKONTO',
            sachkonto: (this.sachkontoCtrl.value || '').trim() || null,
            kostenstelle_suffix: (this.suffixCtrl.value || '').trim() || null,
            aktiv: this.aktivCtrl.value ? 1 : 0,
            kommentar: (this.kommentarCtrl.value || '').trim() || null,
        };
        if (this.fibuKontoId) {
            body.fibu_konto_id = this.fibuKontoId;
        }

        this.api.post(this.apiBaseUrl + 'fibu_konto/update.php', body).subscribe({
            next: () => {
                this.messageService.infoMessage('Konto gespeichert.');
                this.dialogRef.close(true);
            },
            error: err => this.messageService.errorMessage('Speichern fehlgeschlagen.', err),
        });
    }

    close() {
        this.dialogRef.close(false);
    }
}
